import Header from "../components/header/Header";
import "./layout.css";

export default function MainLayout({ children, onMenuClick }) {
  return (
    <div className="wrapper">
      <div className="mobile">
        <Header onMenuClick={onMenuClick} />
        <div className="content">{children}</div>
      </div>
    </div>
  );
}